import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { tryFormatDate } from '@netwealth/nw-utils';

const PARSE_FORMAT: string = 'dd/MM/yyyy HH:mm:ss';
const DISPLAY_FORMAT: string = 'dd MMMM yyyy';

@Component({
    selector: 'nw-author-block',
    imports: [NgOptimizedImage],
    templateUrl: './author-block.component.html',
    styleUrl: './author-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorBlockComponent implements OnChanges {
    @Input() pictureurl!: string;
    @Input() picturealt!: string;
    @Input() name!: string;
    @Input() date?: Date;
    @Input() jobtitle?: string;
    @Input() content?: string;

    public formattedDate?: string;
    public timeToRead?: number;

    public ngOnChanges({ date, content }: SimpleChanges): void {
        if (date) {
            this.formattedDate = tryFormatDate(this.date, DISPLAY_FORMAT, PARSE_FORMAT);
        }
        if (content?.currentValue) {
            this.calculateReadingTime(this.content!);
        }
    }

    private calculateReadingTime(content: string): void {
        const TEXT_AREA: HTMLTextAreaElement = document.createElement('textarea');
        TEXT_AREA.innerHTML = content;

        const STRIPPED_TEXT: string = TEXT_AREA.value.replace(/<[^>]*>/g, '');
        const WORDS: string[] = STRIPPED_TEXT.match(/\b\w+\b/g) || [];
        const PUNCTUATIONS: string[] =
            STRIPPED_TEXT.match(/[.,\\/#!$%\\^&\\*;:{}=\-_`~()?"']/g) || [];

        this.timeToRead = Math.ceil((WORDS.length + PUNCTUATIONS.length) / 238);
    }
}
